// extracted by mini-css-extract-plugin
export default {"msgM":"_68fc74bc75"};